import { Tooltip, TooltipPosition } from 'components/tooltip';
import classNames from 'classnames';
import styles from './SportNavFiltersContainer.module.scss';

export type SportNavFiltersContainerProps = {
  title: string;
  children?: React.ReactNode;
  tooltipContent: string;
  hasBorderBottom?: boolean;
};

export const SportNavFiltersContainer = ({
  title,
  children,
  tooltipContent,
  hasBorderBottom,
}: SportNavFiltersContainerProps) => {
  return (
    <div className={classNames(styles.container, { [styles.hasBorderBottom]: hasBorderBottom })}>
      <div className={styles.text}>
        <span className={styles.title}>{title}</span>
        <Tooltip
          content={tooltipContent}
          iconColor="--color-on-bg-secondary"
          position={TooltipPosition.BOTTOM}
          containerClassName={styles.tooltip}
        />
      </div>
      {children}
    </div>
  );
};
